import type { OpKind, OutboxOp, UserStore } from './store';

export interface HazardOpInput {
  kind: OpKind;
  entityId: string;
  payload: Record<string, unknown>;
  dependsOn?: string;
  status?: 'pending' | 'dead';
  media?: Array<{ id: string; filename: string; mimeType: string; blob: Blob }>;
}

export async function enqueueHazardOp(store: UserStore, input: HazardOpInput): Promise<string> {
  const id = crypto.randomUUID();
  const now = Date.now();
  const op: OutboxOp = {
    id,
    kind: input.kind,
    entityId: input.entityId,
    payload: input.payload,
    attempts: 0,
    nextAttemptAt: now,
    status: input.status ?? 'pending',
    createdAt: now,
  };
  if (input.dependsOn) {
    op.dependsOn = input.dependsOn;
  }
  await store.transaction('rw', [store.outbox, store.outboxMedia], async () => {
    await store.outbox.add(op);
    for (const media of input.media ?? []) {
      await store.outboxMedia.add({
        id: media.id,
        opId: id,
        filename: media.filename,
        mimeType: media.mimeType,
        blob: media.blob,
      });
    }
  });
  return id;
}

export async function listHazardOps(store: UserStore): Promise<OutboxOp[]> {
  return store.outbox.orderBy('createdAt').toArray();
}

export async function hasPendingOutbox(store: UserStore): Promise<boolean> {
  const pending = await store.outbox.filter((op) => op.status === 'pending').count();
  return pending > 0;
}

export async function findHazardOp(
  store: UserStore,
  entityId: string
): Promise<OutboxOp | undefined> {
  return store.outbox.where('entityId').equals(entityId).first();
}
